function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#273359",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "m18.5 15.2255c4.1421 0 7.5-3.125 7.5-6.97983 0-3.85484-3.3579-6.9798-7.5-6.9798s-7.5 3.12496-7.5 6.9798c0 3.85483 3.3579 6.97983 7.5 6.97983z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1 37.9097c0-4.1651 1.7779-8.1596 4.94257-11.1048 3.16468-2.9451 7.45693-4.5997 11.93243-4.5997s8.7677 1.6546 11.9324 4.5997c3.1647 2.9452 4.9426 6.9397 4.9426 11.1048"
}));

var SvgSinglePerson = function SvgSinglePerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 39,
    viewBox: "0 0 36 39",
    width: 36,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSinglePerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/single_person.6d1602ed.svg";
export { ForwardRef as ReactComponent };